import assignDataToMap from "../../utils/AssignDataToMap";
import generateEditorElement from "../../utils/GenerateEditorElement";
import validatorUtil from "../../utils/InputValidator";
import generateEditorConfigs from "../../utils/EditorConfigGenerator";

const useMDEditorDialogControl = ({ configs, value, setValue, error }) => {
  const configEditors = generateEditorConfigs(configs.detail.columns);

  const generateSelectorDialog = ({ field, componentFunction }) => {
    let fieldArr = [];
    if (field.includes(" ")) {
      fieldArr = field.split(" ");
    } else if (field.includes(",")) {
      fieldArr = field.split(",");
    } else {
      fieldArr.push(field);
    }
    for (const fieldSingle of fieldArr) {
      const config = configEditors.find(
        (element) => element.field === fieldSingle
      );
      if (config) {
        config.selectorGenerator = componentFunction;
      }
    }
  };

  // input control
  const handleChange = (field, newValue) => {
    const newMap = { ...value };
    if (!field.includes(".")) {
      newMap[field] = newValue;
    } else {
      assignDataToMap({ key: field, map: newMap, value: newValue });
    }
    setValue(newMap);
  };

  const handleMultipleChange = (mapsNewValue) => {
    const newMap = { ...value };
    for (const mapNewValue of mapsNewValue) {
      newMap[mapNewValue.field] = mapNewValue.newValue;
    }
    setValue(newMap);
  };

  const defaultProps = {
    value: value,
    error: error,
    handleInputChange: handleChange,
    handleMultipleInputChange: handleMultipleChange,
  };

  const mapGeneratedElement = {};
  let firstElement = true;
  for (const config of configEditors) {
    let foundEl;
    for (const custEl of configEditors) {
      const { field, element } = custEl;
      if (config.field === field) {
        foundEl = element;
      }
    }
    if (foundEl) {
      mapGeneratedElement[config.field] = foundEl({
        ...defaultProps,
        autoFocus: firstElement,
        config: config,
      });
    } else {
      const generatedElement = generateEditorElement({
        ...defaultProps,
        autoFocus: firstElement,
        config: config,
      });
      if (generatedElement) {
        mapGeneratedElement[config.field] = generatedElement;
      }
    }
    if (firstElement) {
      firstElement = false;
    }
  }

  const elements = mapGeneratedElement;

  const validator = ({
    configs,
    value,
    onError,
    isEmpty,
    isEmptyMessage,
    mustEqual,
    mustEqualMessage,
    isZero,
    isZeroMessage,
  }) => {
    return validatorUtil({
      configs,
      value,
      onError,
      isEmpty,
      isEmptyMessage,
      mustEqual,
      mustEqualMessage,
      isZero,
      isZeroMessage,
    });
  };

  return {
    // methods
    elements,
    generateSelectorDialog,
    // states
    //utils
    validator,
  };
};

export default useMDEditorDialogControl;
